import * as React from 'react';
/**
 *
 * Original name: finder
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2991%3A273
 *
 */
export const FinderFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.01 13c.101 2.165 1.513 3.5 3.74 3.5a4.033 4.033 0 0 0 2.25-.61v3.61H4v-15h7V13h2.983c-.083 1.322-.829 2-2.233 2-1.404 0-2.149-.678-2.233-2H8.01Zm-.456-4.395A.928.928 0 0 0 7.5 9a.928.928 0 0 0 1 1 .928.928 0 0 0 1-1 .928.928 0 0 0-1-1 .928.928 0 0 0-.946.605Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.5 19.5v-8h-3v-7h7v15h-4Zm-.895-9.554A.928.928 0 0 0 15 10a.928.928 0 0 0 1-1 1 1 0 0 0-2 0 .929.929 0 0 0 .605.946Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
